import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
const sizeClasses = {
  sm: "h-6 w-6",
  default: "h-8 w-8",
  lg: "h-12 w-12"
};
export function Loader(t0) {
  const $ = _c(9);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const t2 = sizeClasses[size];
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("relative", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="from-brand-orange/30 to-brand-yellow/30 absolute inset-[-6px] animate-pulse rounded-full bg-linear-to-r blur-lg" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 animate-spin rounded-full"><div className="from-brand-orange to-brand-yellow h-full w-full rounded-full bg-linear-to-r via-transparent p-[2px]"><div className="bg-background h-full w-full rounded-full" /></div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-0 animate-[spin_2s_linear_infinite_reverse]"><div className="bg-brand-orange absolute top-0 left-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1 rounded-full shadow-[0_0_6px_rgba(251,77,1,0.8)]" /><div className="bg-brand-yellow absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 translate-y-1 rounded-full shadow-[0_0_6px_rgba(253,235,143,0.8)]" /></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute inset-0 flex items-center justify-center"><div className="from-brand-orange to-brand-yellow h-2 w-2 animate-[pulse_1.5s_ease-in-out_infinite] rounded-full bg-linear-to-r shadow-[0_0_8px_rgba(251,77,1,0.6)]" /></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t3) {
    t8 = <div className={t3}>{t4}{t5}{t6}{t7}</div>;
    $[7] = t3;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}